import React from 'react';
import c from 'classnames';
import { CoreLink } from '@uncinc/react-drupal-core';

import Card from '../Card';
import type { ListCardProps } from '../Card/types';

import './style.scss';

const ListCard: React.FC<ListCardProps> = (props) => {
  const {
    title,
    image,
    items,
    className,
    link,
  } = props;

  const classNames = c('ListCard', className);

  return (
    <Card className={classNames}>
      <Card.Image image={image} />

      <Card.Content className="d-block">
        <CoreLink href={link} className="d-inline-block">
          <Card.Title title={title} />
        </CoreLink>

        {items}
      </Card.Content>

    </Card>
  );
};

export default ListCard;
